<template>
  <div class="index-top">
    <div class="task-list" ref="scroll">
      <div class="task-content">
        <div
          class="task-item"
          v-for="(item, index) in taskList"
          :key="index"
          :class="!item.prize ? 'begin' : 'finish'"
          @click="doTask(item, index)"
        >
          <div v-if="!item.prize">?元</div>
          <div v-else>{{ item.prize.value }}<span v-if="item.prize.category === 'redpack'">元</span></div>
          <div class="text">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <router-link class="index-btn" to="/share"></router-link>
  </div>
</template>
<script>
import BScroll from '@better-scroll/core';
import once from 'lodash/once';
export default {
  data() {
    return {
      bs: null,
    };
  },
  props: {
    taskList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  watch: {
    taskList() {
      this.bs?.refresh();
      this.initScroll();
    },
  },
  methods: {
    initScroll: once(function () {
      this.$nextTick(() => {
        this.bs = new BScroll(this.$refs['scroll'], {
          scrollX: true,
          scrollY: false,
          click: true,
          probeType: 2,
        });
      });
    }),
    doTask(item, index) {
      this.$emit('clickCompleteTask', { task: item, index });
    },
  },
  beforeDestroy() {
    this.bs?.destroyed?.();
  },
};
</script>

<style scoped lang="scss">
.index-top {
  width: 750px;
  height: 641px;
  background: url(~@this/assets/index.jpg) center/contain no-repeat;
  position: relative;
}
.index-btn {
  width: 437px;
  height: 100px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 480px;
  background: url(~@this/assets/index-btn.png) center/contain no-repeat;
}
.task-list {
  position: absolute;
  top: 255px;
  width: 750px;
  height: 205px;
  overflow: hidden;
  .task-content {
    white-space: nowrap;
    display: inline-block;
  }
  .task-item:first-child {
    margin-left: 50px;
  }
  .task-item:last-child {
    margin-right: 50px;
  }
  .task-item {
    display: inline-block;
    margin: 0 22px;
    position: relative;
    &.begin {
      width: 130px;
      height: 156px;
      background: url(~@this/assets/rp-icon1.png) center/contain no-repeat;
      > div:not(.text) {
        position: absolute;
        width: 100%;
        top: 92px;
        font-size: 34px;
        color: #fef9b9;
        text-align: center;
      }
    }
    &.finish {
      width: 130px;
      height: 156px;
      background: url(~@this/assets/rp-icon2.png) center/contain no-repeat;
      > div:not(.text) {
        position: absolute;
        width: 100%;
        top: 36px;
        font-size: 20px;
        color: #ff2f40;
        text-align: center;
      }
    }
    .text {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      color: #fffde0;
      font-size: 22px;
      top: 165px;
    }
  }
}
</style>
